<template>
    <div>

        <div class="nk-block">
            <div class="row g-gs">

                <div class="col-md-12">

                    <div class="row">
                        <div class="col-md-12">
                            <div class="card card-bordered">
                                <div class="card-inner">

                                    <div class="row">

                                        <div class="col">

                                            <div class="form-group">
                                                <label class="form-label">{{ translations.difficulty }}</label>
                                                <div class="form-control-wrap">
                                                    <select class="form-control" id="difficultyId" v-model="difficulty_selected" v-on:change="fetchResults($event)">
                                                        <option value=""></option>
                                                        <option v-for="difficulty in event.difficulties" :key="difficulty.id" :value="difficulty.id">{{ difficulty.title }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="col">

                                            <div class="form-group">
                                                <label class="form-label">{{ translations.tour_number }}</label>
                                                <div class="form-control-wrap">
                                                    <div class="form-control-select">
                                                        <select class="form-control" id="tourId" v-on:change="fetchResults($event)">
                                                            <option value=""></option>
                                                            <option v-for="tour in event.tours" :key="tour.id" :value="tour.id" v-if="tour.difficulty_id == difficulty_selected">{{ tour.order }} ({{ tour.difficulty.title }})</option>
                                                            <option value="-1">{{ translations.final_result }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="nk-block">
            <div class="row g-gs">

                <div class="col-md-12">
                    <div class="card card-bordered">

                        <div class="card-inner">

                            <div class="card-title-group mt-3 mb-3 d-flex justify-content-end">
                                <div class="card-tools mt-n4 mr-n1">
                                    <button class="btn btn-sm btn-primary" v-on:click="printResults">{{ translations.print.print_results }}</button>
                                </div>
                            </div>

                            <div id="printArea">

                                <!-- Printable content -->
                                <div class="row justify-content-center d-none d-print-flex text-center pb-3">
                                    <h5 class="text-center" id="printTitle"></h5>
                                </div>

                                <!-- printable content -->
                                <div class="row justify-content-between d-none d-print-flex pb-2 pr-1">
                                    <img src="https://i.imgur.com/SyA3kFk.png" class="img-responsive" style="max-width: 250px;max-height: 70px;height: auto;width: auto;" alt="RPR logo"> <!-- LOGO of the organisation -->
                                    <img src="https://i.imgur.com/cKlBQpI.gif" class="img-responsive" style="max-width: 250px;max-height: 70px;height: auto;width: auto;" alt="Scuderia Vervica"> <!-- LOGO of the CLUB -->
                                    <img src="https://i.imgur.com/5mZTKMX.jpeg" class="img-responsive" alt="VAS" style="width: 100px;height: auto"> <!-- Default VAS logo -->
                                </div>

                                <div class="row">
                                    <div class="col">

                                        <table v-if="this.tour !== '-1'" style="max-width: 100vw;" class="table table-bordered table-responsive">
                                            <thead>
                                                <tr>
                                                    <th scope="col" colspan="2"></th>
                                                    <th scope="col" colspan="3">{{ translations.table.header.pilot }}</th>
                                                    <th scope="col" colspan="3">{{ translations.table.header.co_pilot }}</th>
                                                    <th scope="col" colspan="7"></th>
                                                </tr>
                                                <tr>
                                                    <th scope="col">{{ translations.table.header.pos }}</th>
                                                    <th scope="col">{{ translations.table.header.team_number }}</th>

                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.name }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.club }}</th>
                                                    <th scope="col">{{ translations.table.header.license }}</th>

                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.name }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.club }}</th>
                                                    <th scope="col">{{ translations.table.header.license }}</th>

                                                    <th scope="col">{{ translations.table.header.error_distance }}</th>
                                                    <th scope="col">{{ translations.table.header.total_gtc }}</th>
                                                    <th scope="col">{{ translations.table.header.total_time_controls }}</th>
                                                    <th scope="col">{{ translations.table.header.total_controls }}</th>
                                                    <th scope="col">{{ translations.table.header.total }}</th>
                                                    <th scope="col"><!-- DNF/out of time --></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(result, index) in results" :key="result.id">
                                                    <th scope="row">{{ (parseInt(index) + 1) }}</th>
                                                    <td>{{ result.team_number }}</td>

                                                    <td  nowrap="nowrap">
                                                        {{ result.team.pilot.lastname }} {{ result.team.pilot.firstname }}
                                                        <i class="fas fa-venus fa-xs" v-if="result.team.pilot.is_female"></i>
                                                        <i class="fas fa-home fa-xs" v-if="result.team.pilot.is_resident"></i>
                                                    </td>
                                                    <td  nowrap="nowrap">{{ result.team.pilot.club }}</td>
                                                    <td>{{ result.team.pilot.license_number }}</td>

                                                    <td  nowrap="nowrap">
                                                        {{ result.team.co_pilot.lastname }} {{ result.team.co_pilot.firstname }}
                                                        <i class="fas fa-venus fa-xs" v-if="result.team.co_pilot.is_female"></i>
                                                        <i class="fas fa-home fa-xs" v-if="result.team.co_pilot.is_resident"></i>
                                                    </td>
                                                    <td  nowrap="nowrap">{{ result.team.co_pilot.club }}</td>
                                                    <td>{{ result.team.co_pilot.license_number }}</td>

                                                    <td>{{ result.points_for_distance }}</td>
                                                    <td>{{ result.points_for_gtc }}</td>
                                                    <td>{{ result.points_for_time }}</td>
                                                    <td>{{ result.missed_controls }}</td>
                                                    <td>{{ result.total }}</td>
                                                    <td v-if="result.dnf === true">{{ translations.table.content.dnf }}</td>
                                                    <td v-else-if="result.out_of_time === true">{{ translations.table.content.out_of_time }}</td>
                                                    <td v-else></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table v-if="this.tour === '-1'" style="max-width: 100vw;" class="table table-bordered table-responsive">
                                            <thead>
                                                <tr>
                                                    <th nowrap="nowrap" scope="col" colspan="2"></th>
                                                    <th nowrap="nowrap" scope="col" colspan="3">{{ translations.table.header.pilot }}</th>
                                                    <th nowrap="nowrap" scope="col" colspan="3">{{ translations.table.header.co_pilot }}</th>
<!--                                                    <th nowrap="nowrap" scope="col" colspan="3" v-for="tour in event.tours">Tour {{ tour.order }}</th>-->
                                                    <th nowrap="nowrap" scope="col" colspan="3" v-for="x in 2">Deel {{ x }}</th>
                                                    <th nowrap="nowrap" scope="col" colspan="3">Eind</th>
                                                    <th nowrap="nowrap" scope="col"></th>
                                                </tr>
                                                <tr>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.pos }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.team_number }}</th>

                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.name }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.club }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.license }}</th>

                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.name }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.club }}</th>
                                                    <th nowrap="nowrap" scope="col">{{ translations.table.header.license }}</th>

<!--                                                    <template v-for="tour in event.tours">-->
<!--                                                        <th nowrap="nowrap" scope="col">{{ translations.table.header.total_gtc }}</th>-->
<!--                                                        <th nowrap="nowrap" scope="col">{{ translations.table.header.total_time_controls }}</th>-->
<!--                                                        <th nowrap="nowrap" scope="col">{{ translations.table.header.total_controls }}</th>-->
<!--                                                    </template>-->
                                                    <template v-for="x in 2">
                                                        <th nowrap="nowrap" scope="col">{{ translations.table.header.total_gtc }}</th>
                                                        <th nowrap="nowrap" scope="col">{{ translations.table.header.total_time_controls }}</th>
                                                        <th nowrap="nowrap" scope="col">{{ translations.table.header.total_controls }}</th>
                                                    </template>

                                                    <th nowrap="nowrap">{{ translations.table.header.total_gtc }}</th>
                                                    <th nowrap="nowrap">{{ translations.table.header.total_time_controls }}</th>
                                                    <th nowrap="nowrap">{{ translations.table.header.total_controls }}</th>
                                                    <th nowrap="nowrap"></th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(result, index) in results" :key="result.id">
                                                    <th scope="row">{{ (parseInt(index) + 1) }}</th>
                                                    <td>{{ result.team_number }}</td>

                                                    <td nowrap="nowrap">
                                                        {{ result.team.pilot.lastname }} {{ result.team.pilot.firstname }}
                                                        <i class="fas fa-venus fa-xs" v-if="result.team.pilot.is_female"></i>
                                                        <i class="fas fa-home fa-xs" v-if="result.team.pilot.is_resident"></i>
                                                    </td>
                                                    <td nowrap="nowrap">{{ result.team.pilot.club }}</td>
                                                    <td nowrap="nowrap">{{ result.team.pilot.license_number }}</td>

                                                    <td nowrap="nowrap">
                                                        {{ result.team.co_pilot.lastname }} {{ result.team.co_pilot.firstname }}
                                                        <i class="fas fa-venus fa-xs" v-if="result.team.co_pilot.is_female"></i>
                                                        <i class="fas fa-home fa-xs" v-if="result.team.co_pilot.is_resident"></i>
                                                    </td>
                                                    <td nowrap="nowrap">{{ result.team.co_pilot.club }}</td>
                                                    <td nowrap="nowrap">{{ result.team.co_pilot.license_number }}</td>

                                                    <template v-for="tour_result in result.tour_details">
                                                        <td>{{ tour_result.points_for_gtc }}</td>
                                                        <td>{{ tour_result.points_for_time }}</td>
                                                        <td>{{ tour_result.total }}</td>
                                                    </template>

                                                    <td>{{ result.total_gtc }}</td>
                                                    <td>{{ result.total_time }}</td>
                                                    <td>{{ result.total_points }}</td>
                                                    <td v-if="result.total_dnf">DNF</td>
                                                    <td v-else></td>

                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                </div>

                                <!-- footer content -->
                                <div class="row" style="position:absolute;bottom: 0;width: 100%;font-size: 11px">
                                    <div class="justify-content-between d-none d-print-flex">
                                        <div class="">
                                            {{ translations.print.date_print }}: <span id="printDate"></span>
                                        </div>
                                        <div class="text-center">
                                            <img src="/images/logos/DotRide.png" alt="logo-dark" style="height: 25px;width: 115px">
                                        </div>
                                        <div class="">
                                            <span class="float-right">{{ translations.print.race_director }}: {{ event.race_director }}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper);

export default {
    name: "organisationDotresultResults",

    props: [
        'organisation',
        'event',
        'translations',
    ],

    data() {
        return {
            results: {},
            tour: null,
            difficulty_selected: null,
        }
    },

    methods: {
        fetchResults(event) {
            let difficultyId = $('select#difficultyId').val(),
                tourId = $('select#tourId').val();

            this.tour = tourId; // set the tour property in vue

            if (difficultyId.length && tourId.length) {
                axios.get('/api/internal/dotresult/get-results', {
                    params: {
                        event_id: this.event.id,
                        tour_id: tourId,
                        difficulty_id: difficultyId
                    }
                }).then((response) => {
                    // Process response into table
                    this.results = {};
                    this.results = Object.assign({}, this.results, response.data);
                });
            }
        },

        async printResults () {
            // Pass the element id here

            let print_title = this.event.name + ' - uitslag ' + $('select#difficultyId option:selected').text();

            if ($('select#tourId').val() !== "-1") {
                print_title += ' deel ' + $('select#tourId option:selected').text();
            }

            $('#printTitle').html(print_title); // sets the print title

            let date = new Date();

            function addZero(i)
            {
                if (i < 10) {
                    i = "0" + i;
                }
                return i;
            }

            let printDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes()) + ':' + addZero(date.getSeconds());

            $('#printDate').html(printDate);

            $('table').removeClass('table-responsive').css({
                'font-size': '75%'
            });

            await this.$htmlToPaper('printArea', {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=no',
                    'width=800',
                    'height=600',
                    'toolbar=no',
                    'location=no',
                    'directories=no',
                    'status=no',
                    'menubar=no',
                    'copyhistory=no'
                ],
                styles: [
                    'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css',
                    'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css',
                ],
                timeout: 1000, // default timeout before the print window appears
                autoClose: true, // if false, the window will not close after printing
                windowTitle: print_title, // override the window title
            }, () => {
                console.log("Printed or closed");
                $('table').addClass('table-responsive').css({
                    'font-size': '100%'
                });
            });
        }
    },
}
</script>

<style scoped>

</style>
